import { Box, Typography } from "@mui/material"
import React from "react"

type ProvidersCellProps = {
  row: any
}

const ProvidersCell = (props: ProvidersCellProps) => {
  const { row } = props

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex" }}>
        <Typography fontSize={14}>{row.original.Provider}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {/* <Typography color="gray" fontSize={10}>
          {row?.original?.Group}
        </Typography>
        <Typography color="gray" fontSize={10}>
          {row?.original?.Region}
        </Typography> */}
        <Typography color="gray" fontSize={10}>
          {row?.original?.Office}
        </Typography>
      </Box>
    </Box>
  )
}

export default ProvidersCell
